// One hash, shared by everything that snapshots locked Accelerator prose.
//
// Momentum records that came across from the Accelerator store the exact text
// they were built from plus a hash of it (`sourceText` / `sourceHash`). Later,
// hashing the CURRENT locked text and comparing is how a record knows she has
// re-locked the module since — which is what puts "May need refresh" on an offer
// and "Your Accelerator copy changed" on a website page.
//
// This lived privately inside offerParse.js until website sections needed the
// same thing. It must stay byte-identical to that original: offers already in
// Supabase carry hashes produced by it, and a different algorithm would make
// every one of them read as changed.

/** Stable 32-bit string hash, returned as a string. Not cryptographic — it only
 *  ever answers "is this the same text as before?". */
export function hashSource(text) {
  const s = String(text || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return String(h);
}
